import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import SortIcon from "../../../assets/vizr_images/ic_sort-1.svg";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import FilterComponent from "./alertsFilter";
import SortComponent from "../../shared/sortComponent";
import PolicyFilter from "../../shared/policyFilter";
import ClearFilter from "../../shared/clearFilter";
import Popper from "@material-ui/core/Popper";
import { getAlertPolicySeverities } from "../../../redux/actions/getAlertPolicySeveritiesAction";
import { getAlertResolutionTypes } from "../../../redux/actions/getAlertResolutionTypesAction";
import { getAllAlertPolicyNames } from "../../../redux/actions/getAllAlertPolicyNamesAction";
import { updateAlertStatus } from "../../../redux/actions/updateAlertStatusAction";
import { ColorButtonForToolBar } from "../../common/buttons";
import { GET_ALL_DATA_SOURCES_TYPES, inactivePopupActivateList, updateAlert } from "../../../redux/constants/constants";
import ImageTooltip from "../../common/HelpIconWithTooltip";
import SelectedFiltersView from "./SelectedFiltersView"
import { cloneDeep } from "lodash";
import CanAllow from "../CanAllow";
import { CREATE_JIRA_INCIDENT } from "../../../features/SysGuard/sysGuardConstants";
import { renderRevokePopup } from "../../common/utilities";
import { toggleUserInList } from "../../common/commonUtilities";
import AcceptRiskPopup from "./AcceptriskPopup";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  paper: {
    width: "100%",
  },
}));

export const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    totalElements,
    rows,
    policyId,
    loc,
    alertsTitle,
    severityFilter,
    resolutionFilter,
    policyFilter,
    datasourceFilter,
    selectedRows,
    selectedReportIncidentIds,
    dataLoaded,
    hideAction,
    helpDescription,
    sortByAlert,
    sortOrderAlert,
    applyFilter,
    filterDataInfo,
    toTimeRangeAlert,
    fromTimeRangeAlert,
    show,
    project,
    loader,
    selectedUsersFilter,
    setSelectedUsersFilter
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState();
  const [alertPolicySeverities, setAlertPolicySeverities] = useState([]);
  const [alertResolutionTypes, setAlertResolutionTypes] = useState([]);
  const [policyArr, setPolicyArr] = useState([]);
  const [disableButton, setDisableButton] = useState(true);
  const [severity, setSeverityFilter] = useState([]);
  const [resolution, setResolutionFilter] = useState([]);
  const [policy, setPolicyFilter] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [filterInfo,setFilterInfo] = useState([]);
  const [toTimeRange , setToTimeRange]= useState("");
  const [fromTimeRange , setFromTimeRange]= useState("");
  const [dataSourceTypeFilter, setDataSourceTypeFilter] = useState([]);
  const [datasource, setDatasourceFilter] = useState([]);
  const [userNameFilter, setUserNameFilter] = useState([]);
  const dispatch = useDispatch();
  const [revokeDetails, setRevokeDetails] = useState(null);
  const [revokePopup, setRevokePopup] = useState(false);
  const [mafPopUp, setMafPopup] = useState(false);

  const permissions = useSelector((state) => state.applicationData.permissions);
  const dataSourceTypeFromReducer = useSelector(
    (state) => state.databaseLogsReducer.dataSourceType
  );


  const allowedDataSourceTypes = [
    "PostgreSQL",
    "MSSQL",
    "MySQL",
    "SQLServer",
    "Other",
    "OneDrive",
    "Dropbox",
    "GoogleDrive",
    "NTFS"
  ];

  const dataSourceType = useMemo(() => {
    if (!dataSourceTypeFromReducer || !Array.isArray(dataSourceTypeFromReducer)) {
      return [];
    }
    return dataSourceTypeFromReducer.filter((ds) =>
      allowedDataSourceTypes.includes(ds.value)
    );
  }, [dataSourceTypeFromReducer]);

  useEffect(() => {
    async function getResolutionTypes() {
      const response = await getAlertResolutionTypes();
      if (response) {
        setAlertResolutionTypes(response.content);
      }
    }
    getResolutionTypes();
  }, []);

  useEffect(() => {
    async function getPolicyNames() {
      const response = await getAllAlertPolicyNames();
      if (response) {
        setPolicyArr(response);
      }
    }
    getPolicyNames();
  }, []);

  useEffect(() => {
    async function getSeverities() {
      const response = await getAlertPolicySeverities();
      if (response) {
        setAlertPolicySeverities(response.content);
      }
    }
    getSeverities();
    dispatch({
      type: GET_ALL_DATA_SOURCES_TYPES,
    })
  }, []);

  useEffect(() => {
    setSeverityFilter(severityFilter);
    setResolutionFilter(resolutionFilter);
    setPolicyFilter(policyFilter);
    setSortBy(sortByAlert);
    setSortOrder(sortOrderAlert);
    setDataSourceTypeFilter(dataSourceTypeFilter);
    setDatasourceFilter(datasourceFilter);
    setUserNameFilter(userNameFilter);
    setFilterInfo(cloneDeep(filterDataInfo))
  }, []);

  useEffect(() => {
    setToTimeRange(toTimeRangeAlert)
    setFromTimeRange(fromTimeRangeAlert)
  }, [fromTimeRangeAlert , toTimeRangeAlert]);

  useEffect(() => {
    if (rows && rows.length > 0) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [rows]);

  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
    setValues();
  };

  const setValues = () => {
    setSeverityFilter(severityFilter);
    setResolutionFilter(resolutionFilter);
    setPolicyFilter(policyFilter);
    setSortBy(sortByAlert);
    setSortOrder(sortOrderAlert);
    setDataSourceTypeFilter(dataSourceTypeFilter);
    setDatasourceFilter(datasourceFilter);
    setUserNameFilter(userNameFilter);
    setFilterInfo(cloneDeep(filterDataInfo));
  };

  const handleDbSelectUsers = (selectedUsers, user) => {
    setSelectedUsersFilter((prev) => toggleUserInList(prev, user));
    let finalInfoBackup = filterInfo;
    finalInfoBackup.push({
      type: "users",
      name: user,
      data: {code: user, value: user},
      value: user,
    });
    setFilterInfo(finalInfoBackup);
    if (!userNameFilter.includes(user)) {
      setUserNameFilter([...userNameFilter, user]);
    }
  };

  //this method is used in the sort and filter component
  const handleCheckbox = (event, type,data) => {
    if (event.target.checked) {
      if (type === "severity") {
        let finalInfoBackup = filterInfo
        finalInfoBackup.push({type:type, name:data.code ,data:data ,value:event.target.value})
        setFilterInfo(finalInfoBackup)
        if (!severity.includes(event.target.value)) {
          setSeverityFilter([...severity, event.target.value]);
        }
      } else if (type === "resolutionType") {
        if (!resolution.includes(event.target.value)) {
          let finalInfoBackup = filterInfo
          finalInfoBackup.push({type:type, name:data.value,data:data,value:event.target.value})
          setFilterInfo(finalInfoBackup)
          setResolutionFilter([...resolution, event.target.value]);
        }
      } else if (type === "policy") {
        let finalInfoBackup = filterInfo
        finalInfoBackup.push({type:type, name:data.name,data:data,value:event.target.value})
        setFilterInfo(finalInfoBackup)
        if (!policy.includes(event.target.value)) {
          setPolicyFilter([...policy, event.target.value]);
        }
      } else if (type === "dataSourceType") {
        let finalInfoBackup = filterInfo
        finalInfoBackup.push({type:type, name:data.code,data:data,value:event.target.value})
        setFilterInfo(finalInfoBackup)
        if (!dataSourceTypeFilter.includes(event.target.value)) {
          setDataSourceTypeFilter([...dataSourceTypeFilter, event.target.value]);
        }
      } else if (type === "datasource") {
        let finalInfoBackup = filterInfo
        let name = data.databaseName ? data.databaseName : data.aliasName + ' (' + data.domainName + ')'
        finalInfoBackup.push({type:type, name:name,data:data,value:event.target.value})
        setFilterInfo(finalInfoBackup)
        if (!datasource.includes(event.target.value)) {
          setDatasourceFilter([...datasource, event.target.value]);
        }
      }
    } else {
      if (type === "severity") {
        let finalInfoBackup = filterInfo.filter((each) => each.name !== data.code);
        setFilterInfo(finalInfoBackup)
        let temp = severity.filter((each) => each !== event.target.value);
        setSeverityFilter(temp);
      } else if (type === "resolutionType") {
        let finalInfoBackup = filterInfo.filter((each) => each.name !== data.value);
        setFilterInfo(finalInfoBackup)
        let temp = resolution.filter((each) => each !== event.target.value);
        setResolutionFilter(temp);
      } else if (type === "policy") {
        let finalInfoBackup = filterInfo.filter((each) => each.name !== data.name);
        setFilterInfo(finalInfoBackup)
        let temp = policy.filter((each) => each !== event.target.value);
        setPolicyFilter(temp);
      }
      else if (type === "dataSourceType") {
        let finalInfoBackup = filterInfo.filter((each) => each.name !== data.code);
        setFilterInfo(finalInfoBackup)
        let temp = dataSourceTypeFilter.filter((each) => each !== event.target.value);
        setDataSourceTypeFilter(temp);
      } else if (type === "datasource") {
        let name = data.databaseName ? data.databaseName : data.aliasName + ' (' + data.domainName + ')'
        let finalInfoBackup = filterInfo.filter((each) => each.name !== name);
        setFilterInfo(finalInfoBackup)
        let temp = datasource.filter((each) => each !== event.target.value);
        setDatasourceFilter(temp);
      }
    }
  };

  const handleOnChipDelete = (value, type,data) =>{
    if (type === "severity") {
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.code);
      setFilterInfo(finalInfoBackup)
      let temp = severity.filter((each) => each !== value);
      setSeverityFilter(temp);
    } else if (type === "resolutionType") {
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.value);
      setFilterInfo(finalInfoBackup)
      let temp = resolution.filter((each) => each !== value);
      setResolutionFilter(temp);
    } else if (type === "policy") {
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.name);
      setFilterInfo(finalInfoBackup)
      let temp = policy.filter((each) => each !== value);
      setPolicyFilter(temp);
    } else if (type === "dataSourceType") {
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.code);
      setFilterInfo(finalInfoBackup)
      let temp = dataSourceTypeFilter.filter((each) => each !== value);
      setDataSourceTypeFilter(temp);
    } else if (type === "datasource") {
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.name);
      setFilterInfo(finalInfoBackup)
      let temp = datasource.filter((each) => each !== value);
      setDatasourceFilter(temp);
    } else if (type === "users") {
      setSelectedUsersFilter((prev) => toggleUserInList(prev, value));
      let finalInfoBackup = filterInfo.filter((each) => each.name !== data.code);
      setFilterInfo(finalInfoBackup)
      let temp = dataSourceTypeFilter.filter((each) => each !== value);
      setUserNameFilter(temp);
    }
  }

  const clearFilterData = () => {
    setSeverityFilter([]);
    setResolutionFilter([]);
    setPolicyFilter([]);
    setSortBy("");
    setSortOrder("");
    setOpen(false)
    setFilterInfo([])
    setToTimeRange("")
    setFromTimeRange("")
    setDataSourceTypeFilter([]);
    setDatasourceFilter([]);
    setUserNameFilter([]);
    setSelectedUsersFilter([]);
    props.clearFilterData();
  };

  const handleSorting = (event) => {
    setSortOrder("ASC");
    setSortBy(event.target.value);
  };

  const handleSortOrder = (value) => {
    setSortOrder(value);
  };

  const handleApplyFilter = () =>{
    applyFilter(severity,resolution,policy,dataSourceTypeFilter,datasource,userNameFilter,sortBy,sortOrder,filterInfo ,fromTimeRange ,toTimeRange)
    setOpen(false)
  }
  const handleCloseButton = () =>{
    setToTimeRange(toTimeRangeAlert)
    setFromTimeRange(fromTimeRangeAlert)
    setOpen(false)
  }

  const handleOnDateChange = (startDate , endDate) =>{
    setToTimeRange(endDate)
    setFromTimeRange(startDate)
  }
  
  const renderHeaderTitle = () => {
    return (
      <Grid style={{ display: "flex" }} item xs={5}>
        {selectedRows.length > 0 && loc === "alerts" ? (
          <Typography
            className="title"
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {selectedRows.length} selected
          </Typography>
        ) : (
          ""
        )}
        <Typography
          className="title"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {alertsTitle}
        </Typography>
        {!hideAction && (
          <p style={{ margin: "11px 5px 0px 0px", minWidth: "45px" }}>
            Total :
          </p>
        )}
        {!hideAction && <div className="count">{totalElements}</div>}
        {!hideAction && <ImageTooltip description={helpDescription} />}
      </Grid>
    );
  };

  const handleAcceptRiskPopupClose = () => {
    setMafPopup(false);
  };

    const isInactivityEnabled =
      selectedRows &&
      selectedRows?.some((selectedId) =>
        rows.some(
          (row) =>
            row.id === selectedId &&
            inactivePopupActivateList.includes(row.alertPolicy?.name),
        ),
      );
    const selectedRowDetails =
      rows?.filter((row) => selectedRows?.includes(row.id)) || [];

  const handleAcceptRiskConfirm = ({ reason, tillDateEpoch }) => {
    loader(true);

    if (selectedRows.length === 0) return;

    if (isAcceptRiskEnabled) {
      dispatch(
        updateAlertStatus({
          status: "MARK_ACCEPT_RISK",
          ids: selectedRows,
          reason,
          tillDate: tillDateEpoch,
        }),
      );
      return;
    }

    // Split selected rows
    const selectedRowDetails =
      rows?.filter((row) => selectedRows?.includes(row.id)) || [];

    const inactivityIds = selectedRowDetails
      .filter((row) =>
        inactivePopupActivateList.includes(row.alertPolicy?.name),
      )
      .map((row) => row.id);

    const otherIds = selectedRowDetails
      .filter(
        (row) => !inactivePopupActivateList.includes(row.alertPolicy?.name),
      )
      .map((row) => row.id);

    // Inactivity alerts -> with tillDate
    if (inactivityIds.length) {
      dispatch(
        updateAlertStatus({
          status: "MARK_FALSE_POSITIVE",
          ids: inactivityIds,
          tillDate: tillDateEpoch,
        }),
      );
    }

    // Other alerts -> without tillDate
    if (otherIds.length) {
      dispatch(
        updateAlertStatus({
          status: "MARK_FALSE_POSITIVE",
          ids: otherIds,
        }),
      );
    }
  };

  const handleRevokePopupClose = () => {
    setRevokePopup(false);
  };
  const handleRevokeConfirm = () => {
    loader(true);
    if (selectedReportIncidentIds.length > 0) {
      dispatch({
        type: CREATE_JIRA_INCIDENT,
        payload: { alerts: selectedReportIncidentIds },
      });
    }
    setRevokePopup(false);
  };

  const isAcceptRiskEnabled = selectedRows && selectedRows?.some((selectedId) =>
    rows.some(
      (row) =>
        row.id === selectedId &&
        row.alertPolicy?.name === "MFA Disabled or Modified",
    ),
  );

  const renderButtons = () => {
    return (
      <Grid item xs={7} style={{ float: "right", textAlign: "right" }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{
            color: "#081981",
            backgroundColor: "transparent",
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "none",
          }}
          disabled={dataLoaded ? false : disableButton}
          onClick={handleClick("bottom")}
          startIcon={<img src={SortIcon} alt="sort-filter" />}
          className="min-margin table-buttons"
        >
          Sort & Filter
        </Button>
        {loc === "alerts" && (
          <CanAllow needs={{ permission: [updateAlert] }}>
            <span
              title={
                selectedReportIncidentIds.length === 0
                  ? "Select an unreported alert to report an incident"
                  : ""
              }
            >
              <ColorButtonForToolBar
                variant="contained"
                color="primary"
                size="small"
                disabled={selectedReportIncidentIds.length === 0}
                onClick={() => {
                  setRevokePopup(true);
                }}
                className="min-margin table-buttons"
              >
                Report Incident
              </ColorButtonForToolBar>
            </span>
            <ColorButtonForToolBar
              variant="contained"
              color="primary"
              size="small"
              disabled={disableButton}
              onClick={() => {
                if (selectedRows.length > 0) {
                  dispatch(
                    updateAlertStatus({
                      status: "MARK_RESOLVED",
                      ids: selectedRows,
                    }),
                  );
                }
              }}
              className="min-margin table-buttons"
            >
              Resolve
            </ColorButtonForToolBar>
            <ColorButtonForToolBar
              variant="contained"
              color="primary"
              disabled={disableButton}
              size="small"
              onClick={() => {
                if (selectedRows.length > 0) {
                  if (isInactivityEnabled) {
                    setMafPopup(true);
                  } else {
                    dispatch(
                      updateAlertStatus({
                        status: "MARK_FALSE_POSITIVE",
                        ids: selectedRows,
                      }),
                    );
                  }
                  }
              }}
              className="min-margin table-buttons"
            >
              False Positive
            </ColorButtonForToolBar>
            <ColorButtonForToolBar
              variant="contained"
              color="primary"
              size="small"
              disabled={!isAcceptRiskEnabled}
              onClick={() => {
                setMafPopup(true);
              }}
              className="min-margin table-buttons"
              title="Select an MFA Disabled Policy"
            >
              Accept Risk
            </ColorButtonForToolBar>
          </CanAllow>
        )}
        {renderPopover()}
        {renderRevokePopup(
          revokePopup,
          revokeDetails,
          handleRevokePopupClose,
          handleRevokeConfirm,
          "behavioralAnomalies",
        )}
        <AcceptRiskPopup
          open={mafPopUp}
          onClose={handleAcceptRiskPopupClose}
          onAccept={handleAcceptRiskConfirm}
          loc={selectedRowDetails}
        />
      </Grid>
    );
  };

  const renderPopover = () => {
    return (
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        transition
        style={{
          boxShadow: "0 6px 8px 0 rgb(0 0 0 / 27%)",
          marginTop: "10rem",
          marginRight: "1rem",
          zIndex: "10"
        }}
      >
        {({ TransitionProps }) => (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <>
                <div className="clear-filter-container">
                  <ClearFilter
                    className="clear-filter"
                    clearFilterButtonClick={clearFilterData}
                    toggle={handleClick}
                    handleApplyFilter={handleApplyFilter}
                    handleCloseButton = {handleCloseButton}
                    loc={loc}
                  />
                </div>
                <div className="popper-root" style={{height:"650px"}}>
                  <Fade timeout={350} {...TransitionProps}>
                    <SortComponent
                      sortBy={sortBy}
                      handleSortingFilter={handleSorting}
                      sortOrder={sortOrder}
                      handleSortOrder={handleSortOrder}
                      loc={loc}
                    />
                  </Fade>
                  <Fade timeout={350} {...TransitionProps}>
                    <FilterComponent
                      severityFilter={severity}
                      resolutionFilter={resolution}
                      policy = {policy}
                      severitiesArray={alertPolicySeverities}
                      resolutionTypes={alertResolutionTypes}
                      handleCheckbox={handleCheckbox}
                      policyArr={policyArr}
                      policyId = {policyId}
                      handleOnDateChange={handleOnDateChange}
                      toTimeRange={toTimeRange}
                      fromTimeRange={fromTimeRange}
                      loc={loc}
                      show={show}
                      dataSourceTypeFilter={dataSourceTypeFilter}
                      datasourceFilter={datasource}
                      userNameFilter={userNameFilter}
                      dataSourceType={dataSourceType}
                      project={project}
                      selectedUsersFilter={selectedUsersFilter}
                      handleDbSelectUsers={handleDbSelectUsers}
                    />
                  </Fade>
                 
                  <div
                style={{
                  minheight: "350px",
                  width: "400px",
                  display: "flex",
                  flexDirection: "column",
                  // marginTop: "2rem",
                  paddingLeft: "1.5rem",
                  overflow: "hidden auto",
                }}
              >
                <SelectedFiltersView filterInfo={filterInfo}  handleOnChipDelete={handleOnChipDelete}/>
            
              </div>
                  
                </div>
              </>
            </div>
          </>
        )}
      </Popper>
    );
  };

  const renderGrid = () => {
    return (
      <Grid container spacing={3}>
        {renderHeaderTitle()}
        {!hideAction && renderButtons()}
      </Grid>
    );
  };

  return (
    <Paper className={classes.paper}>
      <Toolbar className="toolbar-root">
        <Grid container spacing={3}>
          {renderGrid()}
        </Grid>
      </Toolbar>
    </Paper>
  );
};

EnhancedTableToolbar.propTypes = {
  totalElements: PropTypes.number.isRequired,
};
